import api from './api';

/**
 * API client for the Vibes feature (Instagram-Stories-style ephemeral posts).
 * Mirrors the shape of feedService: thin wrappers over axios that surface
 * either the response payload or a normalized error.
 */
const handle = (fn) => async (...args) => {
    try {
        const response = await fn(...args);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: error.message || 'Vibe request failed' };
    }
};

const vibesService = {
    // ---- reads ----
    getRail: handle(() => api.get('/vibes/rail')),

    getCreatorVibes: handle((creatorId) => api.get(`/vibes/creator/${creatorId}`)),

    getVibe: handle((vibeId) => api.get(`/vibes/${vibeId}`)),

    getReactions: handle((vibeId) => api.get(`/vibes/${vibeId}/reactions`)),

    getViewers: handle((vibeId) => api.get(`/vibes/${vibeId}/viewers`)),

    // ---- writes ----
    createVibe: handle(({ mediaFileId, caption, visibility }) =>
        api.post('/vibes', { mediaFileId, caption, visibility })),

    deleteVibe: handle((vibeId) => api.delete(`/vibes/${vibeId}`)),

    recordView: (vibeId, completed) =>
        api.post(`/vibes/${vibeId}/view`, { completed: Boolean(completed) })
            .catch(() => { /* view tracking is best-effort */ }),

    setReaction: handle((vibeId, emoji) =>
        api.post(`/vibes/${vibeId}/reactions`, { emoji })),

    removeReaction: handle((vibeId) => api.delete(`/vibes/${vibeId}/reactions`)),

    replyToVibe: handle((vibeId, text) =>
        api.post(`/vibes/${vibeId}/reply`, { text })),

    reportVibe: handle((vibeId, { reason, note }) =>
        api.post(`/vibes/${vibeId}/report`, { reason, note })),
};

export default vibesService;
export { vibesService };
